import React from "react";

import { PitchInformationAboutYourselfDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyPitchAboutYourselfProps = {
  dataInForm: PitchInformationAboutYourselfDataType;
};

const PitchAskForXboxConfig: Map<string, ReadOnlyFormItem> = new Map([
  ["studioBackground", { title: "pitchAboutYourselfTellUsMoreAboutYourselfTitle" }],
  ["activeInLocalGameDev", { title: "pitchAboutYourselfAreYouActiveInTheLocalGameDevTitle" }],
]);

export const ReadOnlyPitchAboutYourself = ({ dataInForm }: ReadOnlyPitchAboutYourselfProps) => (
  <ReadOnlyForm formConfig={PitchAskForXboxConfig} formData={dataInForm} />
);
